class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      // This theme replaced Dawn's header with slab-city-header.liquid, which has
      // its own cart icon and so no #cart-icon-bubble. Skip absent targets rather
      // than throwing: the throw landed before open(), which left the notification
      // populated but parked off-screen, so adds looked like they did nothing.
      if (!target) return;
      target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.updateHeaderCartDot(parsedState.sections['cart-icon-bubble']);

    if (this.header) this.header.reveal();
    this.open();
  }

  // Mirrors Dawn's cart bubble onto this theme's own .sc-cart-dot, so the header
  // badge tracks the cart without importing Dawn's cart-icon markup.
  updateHeaderCartDot(bubbleSectionHTML) {
    const link = document.querySelector('.sc-icon-btn[aria-label="Cart"]');
    if (!link || !bubbleSectionHTML) return;

    const hasItems = new DOMParser()
      .parseFromString(bubbleSectionHTML, 'text/html')
      .querySelector('.cart-count-bubble');
    const dot = link.querySelector('.sc-cart-dot');

    if (hasItems && !dot) {
      const marker = document.createElement('span');
      marker.className = 'sc-cart-dot';
      link.appendChild(marker);
    } else if (!hasItems && dot) {
      dot.remove();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
